import { FC } from 'react'
import { NavLink, type To } from 'react-router'
import cn from 'classnames'
import { Text, TextColor, TextTag, TextVariant } from '@enbw/ui-react'
import styles from './styles.module.scss'

type ContractNavigationItemProps = {
  label: string
  to: To
}

export const ContractNavigationItem: FC<ContractNavigationItemProps> = ({ label, to }) => {
  return (
    <li>
      <NavLink className={({ isActive }) => cn(styles.navigationLink, { [styles.navigationLinkActive]: isActive })} to={to}>
        {({ isActive }) => (
          <Text color={TextColor.Default} variant={isActive ? TextVariant.BodyStandardWeighted : TextVariant.BodyStandard} tag={TextTag.Span}>
            {label}
          </Text>
        )}
      </NavLink>
    </li>
  )
}
